import { render, staticRenderFns } from "./DingTalkCallback.vue?vue&type=template&id=23967c66&scoped=true"
import script from "./DingTalkCallback.vue?vue&type=script&lang=js"
export * from "./DingTalkCallback.vue?vue&type=script&lang=js"
import style0 from "./DingTalkCallback.vue?vue&type=style&index=0&id=23967c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23967c66",
  null
  
)

export default component.exports